import { render, staticRenderFns } from "./addSupervisor.vue?vue&type=template&id=648bd7d5&"
import script from "./addSupervisor.vue?vue&type=script&lang=js&"
export * from "./addSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports